import * as React from 'react';

import { uniqueId } from 'lodash';

interface SliderProps {

    width: number,
    height: number,
    gap: number,
    paginationOn?: boolean
    showInMobile: boolean,
    showInDesctop: boolean,
    parentId?: string,
}

interface SliderState {
    sliderId: string,
    swipeStarted: boolean,
    swipeStartLeft: number,
    swipeCurrentLeft: number,
    swipeCurrentOffset: number,
    contentWidth: number,
    selectedSlide: number,

}

export class Slider extends React.PureComponent<SliderProps, SliderState> {

    constructor(props: SliderProps) {
        super(props);

        this.state = {
            sliderId: uniqueId('slider-'),
            swipeStarted: false,
            swipeStartLeft: 0,
            swipeCurrentLeft: 0,
            swipeCurrentOffset: -(this.props.width + this.props.gap),
            contentWidth: (this.props.children as JSX.Element[]).length * (this.props.width + this.props.gap) - this.props.gap,
            selectedSlide: 1,
        }
    }
    componentDidMount(): void {
        let slider = document.getElementById(this.state.sliderId);
        let isAdditionalShow = slider !== null && this.state.contentWidth > slider?.clientWidth;
        if (!isAdditionalShow) this.setState({ swipeCurrentOffset: 0, selectedSlide: 0 })
    }

    private Slider_onTouchStart(touches: React.TouchList) {
        if (this.props.parentId) document.getElementById(this.props.parentId)?.classList.add("scroll-off")
        let slider = document.getElementById(this.state.sliderId);
        if (slider !== null && this.state.contentWidth > slider?.clientWidth) {
            if (!this.state.swipeStarted && touches.length === 1) this.setState({ swipeStarted: true, swipeStartLeft: touches[0].clientX, swipeCurrentLeft: touches[0].clientX })
            else this.setState({ swipeStarted: false, swipeStartLeft: 0, swipeCurrentLeft: 0 })
        }
    }

    private Slider_onTouchMove(touches: React.TouchList) {
        let slider = document.getElementById(this.state.sliderId);

        if (slider !== null && this.state.contentWidth > slider?.clientWidth) {
            if (this.state.swipeStarted && touches.length === 1) {
                let finalOffset = this.state.swipeCurrentOffset;
                let offset = this.state.selectedSlide * -(this.props.width + this.props.gap) + this.state.swipeCurrentLeft - this.state.swipeStartLeft;
                let sliderWidth = this.state.contentWidth - slider.clientWidth;
                if (offset >= 0) { finalOffset = 0 }
                else finalOffset = offset
                this.setState({ swipeCurrentLeft: touches[0].clientX, swipeCurrentOffset: finalOffset })
            }
            else this.setState({ swipeStarted: false, swipeStartLeft: 0, swipeCurrentLeft: 0 })
        }
    }

    private Slider_onTouchEnd(touches: React.TouchList) {

        if (this.props.parentId && touches.length === 0) document.getElementById(this.props.parentId)?.classList.remove("scroll-off")
        let elementsLength = (this.props.children as JSX.Element[]).length;
        let elementWidth = (this.props.width + this.props.gap);
        let slider = document.getElementById(this.state.sliderId);
        if (slider !== null && this.state.contentWidth > slider?.clientWidth) {
            if (this.state.swipeStarted) {
                let swipeDifference = this.state.swipeCurrentLeft - this.state.swipeStartLeft;

                if (Math.abs(swipeDifference) > 100) {
                    let selectedSlide = this.state.selectedSlide - Math.sign(swipeDifference);
                    let swipeCurrentOffset = -selectedSlide * elementWidth

                    if (Math.abs(swipeCurrentOffset) > this.state.contentWidth) {

                        if (selectedSlide === elementsLength) {
                            selectedSlide = elementsLength;
                            swipeCurrentOffset = -this.state.contentWidth;

                        }
                        else {
                            selectedSlide = 1;
                            swipeCurrentOffset = -this.state.contentWidth - elementWidth;
                        }
                    }
                    else if (swipeCurrentOffset >= 0) {

                        if (selectedSlide === 1) {
                            selectedSlide = 1;
                            swipeCurrentOffset = -elementWidth;
                        }
                        else {
                            selectedSlide = elementsLength;
                            swipeCurrentOffset = 0;
                        }
                    }
                    this.setState({ swipeStarted: false, swipeStartLeft: this.state.swipeCurrentLeft, swipeCurrentLeft: 0, swipeCurrentOffset: swipeCurrentOffset, selectedSlide: selectedSlide })
                }
                else {
                    let swipeCurrentOffset = Math.abs(this.state.selectedSlide * elementWidth) > this.state.contentWidth
                        ? -this.state.contentWidth
                        : this.state.selectedSlide * -elementWidth;
                    if (swipeDifference == 0) swipeCurrentOffset = this.state.swipeCurrentOffset
                    this.setState({ swipeStarted: false, swipeStartLeft: 0, swipeCurrentLeft: 0, swipeCurrentOffset: swipeCurrentOffset })
                }

            }
            else this.setState({ swipeStarted: false, swipeStartLeft: 0, swipeCurrentLeft: 0 })
        }

    }

    public render() {
        let slider = document.getElementById(this.state.sliderId);
        let isAdditionalShow = slider !== null && this.state.contentWidth > slider?.clientWidth;
        return (
            <div className={`slider 
            ${this.props.showInDesctop && "desctop"}
            ${this.props.showInMobile && "mobile"}`}
                id={this.state.sliderId}
                onTouchStart={(e) => this.Slider_onTouchStart(e.touches)}
                onTouchMove={(e) => this.Slider_onTouchMove(e.touches)}
                onTouchEnd={(e) => this.Slider_onTouchEnd(e.touches)}>
                <div className={`slider_slider ${this.state.selectedSlide}`}

                    style={{
                        gap: this.props.gap,
                        height: this.props.height,
                        marginLeft: this.state.swipeCurrentOffset,
                        transition: this.state.swipeStarted ? "0s" : "0.3s"
                    }}
                >
                    {isAdditionalShow && (this.props.children as JSX.Element[])[(this.props.children as JSX.Element[]).length - 1]}
                    {this.props.children}
                    {isAdditionalShow && (this.props.children as JSX.Element[])}
                </div>
                {this.props.paginationOn && isAdditionalShow &&
                    <div className='slider_pagination'>
                        {(this.props.children as JSX.Element[]).map((e, i) => {
                            return <div key={i} className={`
                            ${this.state.selectedSlide === i + 1 && "selected"}
                            ${this.state.selectedSlide > i + 1 && "slided"}`}><div ></div></div>
                        }
                        )}
                    </div>}
            </div>
        );
    }
}
